import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { LocalStorageService } from '@shared/services/storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppSettings, defaults, THEME } from '../settings';

export const USER_KEY = 'usr';
export const CLASS_DARK_THEME = 'theme-pasm-dark';
export const THEME_KEY = 'thm';

export interface User {
  email?: string;
  id: number;
  name?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private notify$ = new BehaviorSubject<any>({});

  private options = defaults;

  private renderer: Renderer2;

  constructor(private store: LocalStorageService, rendererFactory: RendererFactory2) {
      this.renderer = rendererFactory.createRenderer(null, null);
      this.setTheme(this.theme);
  }

  get notify(): Observable<any> {
    return this.notify$.asObservable();
  }

  getOptions(): AppSettings {
    return this.options;
  }

  isDarkTheme() {
    return this.theme === THEME.DARK;
  }

  removeUser() {
    this.store.remove(USER_KEY);
  }

  setLanguage(lang: string) {
    this.options.language = lang;
    this.notify$.next({ lang });
  }

  setLayout(options?: AppSettings): AppSettings {
    this.options = Object.assign(defaults, options);
    return this.options;
  }

  setNavState(type: string, value: boolean) {
    this.notify$.next({ type, value } as any);
  }

  get user() {
    return this.store.getObject(USER_KEY);
  }

  setTheme(value: THEME) {
    this.options.theme = value;
    this.store.set(THEME_KEY, value);
    if (value === THEME.DARK) {
    this.renderer.addClass(document.body, CLASS_DARK_THEME)
    }
    else {
      this.renderer.removeClass(document.body, CLASS_DARK_THEME)
    }
  }

  setUser(value: User) {
    this.store.set(USER_KEY, value);
  }

  switchTheme() {
    if (this.theme === THEME.LIGHT) {
      this.setTheme(THEME.DARK);
    } else {
      this.setTheme(THEME.LIGHT);
    }
  }

  get language() {
    return this.options.language;
  }

  get theme() {
    return this.store.getValue(THEME_KEY) || this.options.theme;
  }
}
